// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import receptionSlotEntity from './entities/reception-slot.json';
import receptionSlotMenu from '../pages/reception-slot/menu.json';
import receptionSlotFullForm from '../pages/reception-slot/forms/full.json';
import receptionSlotContextForm from '../pages/reception-slot/forms/context.json';
import receptionSlotMiniForm from '../pages/reception-slot/forms/mini.json';
import receptionSlotLookupForm from '../pages/reception-slot/forms/lookup.json';
import receptionSlotTableView from '../pages/reception-slot/views/table.json';
import receptionSlotCardsView from '../pages/reception-slot/views/cards.json';
import receptionSlotCalendarView from '../pages/reception-slot/views/calendar.json';
import receptionSlotDashboardView from '../pages/reception-slot/views/dashboard.json';

/** Тип запису «Час прийому» зі сторінками пакета: меню, форми та подання з pages/reception-slot/. */
export const receptionSlotDefinition: IRecordTypeDefinition = {
  ...receptionSlotEntity,
  views: assembleViewSet({
      table: receptionSlotTableView,
      cards: receptionSlotCardsView,
      calendar: receptionSlotCalendarView,
      dashboard: receptionSlotDashboardView,
  }),
  form: receptionSlotFullForm,
  forms: { full: receptionSlotFullForm, context: receptionSlotContextForm, mini: receptionSlotMiniForm, lookup: receptionSlotLookupForm },
  menu: receptionSlotMenu,
} as IRecordTypeDefinition;
